import { configureStore } from '@reduxjs/toolkit';
import trainingReducer from './slices/trainingSlice';
import instructorReducer from './slices/instructorSlice';
import venueReducer from './slices/venueSlice';
import geoReducer from './slices/geoSlice';
import uiReducer from './slices/uiSlice';

// Configure store
export const store = configureStore({
  reducer: {
    training: trainingReducer,
    instructor: instructorReducer,
    venue: venueReducer,
    geo: geoReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['venue/setPendingImageFiles'],
        // Ignore these paths in the state
        ignoredPaths: ['venue.pendingImageFiles'],
      },
    }),
});

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export store
export default store;

